// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AvailabilityController from "./availability_controller"
import DialogController from "./dialog_controller"
import ShuffleController from "./shuffle_controller"

application.register("availability", AvailabilityController)
application.register("dialog", DialogController)
application.register("shuffle", ShuffleController)
